import React from 'react';
import Badge from '@atlaskit/badge';
import { pluralize } from '@css-xp/ppc-utils';
import { Container, AppSubRow as StyledAppSubRow } from './app-rows.styles';

export type AppRowsProps = {
  appsCount: number;
  subRows?: React.ReactNode[];
  isDefaultExpanded?: boolean;
  expandableRowLeftPosition?: string;
  containerPaddingLeft?: string;
  badgeText?: string;
};

export const AppRows = (props: AppRowsProps) => {
  const {
    appsCount,
    subRows,
    isDefaultExpanded,
    expandableRowLeftPosition,
    containerPaddingLeft,
    badgeText = 'installed app',
  } = props;

  return (
    <Container
      isDefaultExpanded={isDefaultExpanded}
      expandableRowLeftPosition={expandableRowLeftPosition}
      containerPaddingLeft={containerPaddingLeft}
      testId="app-rows"
      rowsAsCells={[
        [
          <td key="apps-count">
            <Badge>{`${pluralize(appsCount, badgeText)}`}</Badge>
          </td>,
        ],
      ]}
      subRows={subRows}
    />
  );
};

export const AppSubRow = ({
  children,
  testId = 'app-subrow',
  className,
  paddingLeft,
  ...rest
}: {
  children: React.ReactNode;
  testId?: string;
  className?: string;
  paddingLeft?: string;
}) => {
  return (
    <StyledAppSubRow data-testid={testId} className={className} paddingLeft={paddingLeft} {...rest}>
      {children}
    </StyledAppSubRow>
  );
};
